import { api } from '../config/api'
import { defaultPageSize } from '../utils/constants'
import { generateFilters } from '../utils/filters'
import LocalStorageService from './LocalStorageService'

const baseEndpoint = '/SubtopicApi'

export const getAllFilteredSubtopics = (pageNumber, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllFiltered?${params.toString()}`)
}

export const getSubtopicByLocale = (id) =>
  api.get(`${baseEndpoint}/GetByLocale/${id}`, { params: { locale: LocalStorageService.getLang() } })
